import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '../components/Typography';

// Material icon paths (Code, Lightbulb outlined, Smart toy, Forum), inlined so
// the section doesn't need @mui/icons-material as a dependency.
const ICONS = {
    code: 'M9.4 16.6 4.8 12l4.6-4.6L8 6l-6 6 6 6zm5.2 0 4.6-4.6-4.6-4.6L16 6l6 6-6 6z',
    strategy:
        'M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7m2.85 11.1-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1',
    agents:
        'M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3M7.5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.83 13 9 13s-1.5-.67-1.5-1.5M16 17H8v-2h8zm-1-4c-.83 0-1.5-.67-1.5-1.5S14.17 10 15 10s1.5.67 1.5 1.5S15.83 13 15 13',
    advisory:
        'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1m-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1',
};

// Placeholder copy: the service list and wording are still to be confirmed.
const SERVICES = [
    {
        icon: ICONS.code,
        title: 'Custom software',
        body: 'Web apps, internal tools and cloud services, designed and built end to end. We ship in small increments so you see working software early.',
    },
    {
        icon: ICONS.strategy,
        title: 'AI strategy and integration',
        body: 'Find where AI pays off in your business and fit it into the systems you already run. We start from your data and workflows, not the hype.',
    },
    {
        icon: ICONS.agents,
        title: 'LLM and agent development',
        body: 'Assistants, retrieval and agents built on modern language models. Each comes with evaluation and guardrails so it holds up in production.',
    },
    {
        icon: ICONS.advisory,
        title: 'Technical advisory',
        body: 'Architecture reviews, roadmap planning and hands-on guidance for your team. A senior second opinion before the expensive decisions.',
    },
];

export default function MnemeticServices() {
    return (
        <Box
            component="section"
            id="services"
            aria-labelledby="services-heading"
            // scrollMarginTop keeps the heading clear of the fixed app bar on #services jumps
            sx={{ bgcolor: '#141415', py: { xs: 8, md: 12 }, scrollMarginTop: { xs: 56, sm: 64 } }}
        >
            <Container>
                <Typography id="services-heading" variant="h4" align="center" marked="center">
                    Services
                </Typography>
                <Box
                    component="ul"
                    sx={{
                        listStyle: 'none',
                        p: 0,
                        m: 0,
                        mt: { xs: 6, md: 8 },
                        display: 'grid',
                        gap: 3,
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: 'repeat(2, 1fr)',
                            lg: 'repeat(4, 1fr)',
                        },
                    }}
                >
                    {SERVICES.map((service) => (
                        <Box
                            component="li"
                            key={service.title}
                            sx={{
                                bgcolor: 'primary.main',
                                border: 1,
                                borderColor: 'primary.light',
                                borderRadius: 2,
                                p: 4,
                            }}
                        >
                            <SvgIcon aria-hidden sx={{ color: 'secondary.main', fontSize: 40 }}>
                                <path d={service.icon} />
                            </SvgIcon>
                            <Typography variant="h6" component="h3" sx={{ mt: 2, mb: 1.5 }}>
                                {service.title}
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                {service.body}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Container>
        </Box>
    );
}
